const locale = {
  placeholder: 'ë ì§ ì í',
};

export default locale;
